import { Layout, Skeleton } from 'antd';
import { useResponsive } from '../hooks/useResponsive';

import './AppLayout.css';

const { Header, Content, Sider } = Layout;

const MOBILE_BREAKPOINT = 768;
const EXPANDED_WIDTH = 200;

const LayoutLoading = () => {
  const { isMobile } = useResponsive(MOBILE_BREAKPOINT);

  return (
    <Layout className="custom-layout">
      {!isMobile && (
        <Sider
          width={EXPANDED_WIDTH}
          theme="light"
          className="custom-sider"
          trigger={null}
        />
      )}

      <Layout>
        <Header
          className={`custom-header ${isMobile ? 'mobile-header' : ''}`}
        />
        <Content className="custom-content">
          <Skeleton active />
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutLoading;
